<template>
    <section class="py-16 bg-background">
        <div class="container mx-auto px-6">
            <h2 class="text-3xl font-bold text-center mb-12">Comment ça marche ?</h2>
            <div class="grid md:grid-cols-3 gap-8">
                <div class="card-primary text-center">
                    <h3 class="text-xl font-bold mb-2">1. Inscris-toi</h3>
                    <p>Crée ton compte en 2 minutes et choisis ta région.</p>
                </div>
                <div class="card-primary text-center">
                    <h3 class="text-xl font-bold mb-2">2. Paye pour grimper</h3>
                    <p>Chaque euro dépensé te donne 1 point pour monter dans le classement.</p>
                </div>
                <div class="card-primary text-center">
                    <h3 class="text-xl font-bold mb-2">3. Domine ta région</h3>
                    <p>Sois visible sur la carte et deviens une légende locale.</p>
                </div>
            </div>
        </div>
    </section>
</template>
